import React from 'react'
import MedtechSection1 from '../../MedtechAward/MedtechSection1/MedtechSection1'
import Navbar from "../../LandingPage/Navbar/Navbar"
import MedtechSection2 from '../../MedtechAward/MedtechSection2/MedtechSection2'
import Footer2 from '../../Footer2/Footer2'
import TopBar from '../../EdofSectionNew2/TopBar/TopBar'
const MedtechAwardPage = () => {
  return (
    <div>
      <TopBar/>
      <Navbar/>
      <MedtechSection1/>
      <MedtechSection2/>
      <Footer2/>
    </div>
  )
}

export default MedtechAwardPage
